import { sections } from '../sections/sections';
import './SectionTicker.css';

interface SectionTickerProps {
  activeIndex: number;
  onNavigate: (index: number) => void;
}

/**
 * Bottom ruler-style section navigator.
 * Each section is a tall tick mark with a label; minor ticks fill between them.
 */
export function SectionTicker({ activeIndex, onNavigate }: SectionTickerProps) {
  const minorCount = 4; // minor ticks between each major tick

  return (
    <div className="ruler">
      <div className="ruler__track">
        {sections.map((section, index) => (
          <div key={section.id} className="ruler__segment">
            {/* Major tick */}
            <button
              className={`ruler__tick ruler__tick--major ${activeIndex === index ? 'ruler__tick--active' : ''}`}
              onClick={() => onNavigate(index)}
            >
              <span className="ruler__mark" />
              <span className="ruler__label">{section.navLabel}</span>
            </button>

            {/* Minor ticks between sections */}
            {index < sections.length - 1 &&
              Array.from({ length: minorCount }, (_, i) => (
                <span key={i} className="ruler__tick ruler__tick--minor">
                  <span className="ruler__mark" />
                </span>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
}
